import { z } from 'zod';

export const paginationInput = z.object({
  page: z.number().int().positive().default(1),
  limit: z.number().int().positive().max(500).default(20),
});

export const periodoInput = z.object({
  dataInicio: z.coerce.date().optional(),
  dataFim: z.coerce.date().optional(),
});

export const sortInput = z.object({
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('desc'),
});

export const idInput = z.object({
  id: z.string().uuid('ID inválido'),
});

export const successResponse = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export type PaginationInput = z.infer<typeof paginationInput>;
export type PeriodoInput = z.infer<typeof periodoInput>;
export type SortInput = z.infer<typeof sortInput>;
export type IdInput = z.infer<typeof idInput>;
export type SuccessResponse = z.infer<typeof successResponse>;
